import Vue from 'vue';
import languages from '../languages';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getJSON, justifyLandscape } from './ultile';
import { LANGUAGE_LOCALSTORGE_NAME } from '../languages';
import { mergeGameDomainList } from '@configs/officialTopupNew/globalGameInfoConfig';
import { PRODUCT_TYPE_ALL, PRODUCT_TYPE_OTHER } from './const';
import { trackStagePoint } from '@utiles/officialTopupNew/speedPoint';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import { gameIdTransform } from '@utiles/officialTopupNew/transform';
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';
// 同步index里面的：
export const INIT_LANG_LIST = 'init_lang_list';
export const SWITCH_LANGUAGE = 'switch_language';

const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

/**
 * 获取支付页配置
 * @param {int} game_id 游戏id
 * @param {string} version 版本号 v1 | v2 | v3 | v3.5
 * @returns
 */
const GET_PAGE_URL = `//gstore.${globalConfig.getMainHost()}/config?version=v3.5`;
const JP_GET_PAGE_URL = `//jpstore.${globalConfig.getMainHost()}/config?version=v3.5`;

/** 与后台 CONFIG 一致：这些 gameId 强制走 CP 商品匹配 */
const FORCE_MATCH_CP_PRODUCTID_GAME_IDS = [454, 440];

export const GET_PAY_PAGE_INFO = 'GET_PAY_PAGE_INFO'; // 获取支付页配置
export const SET_PAY_PAGE_INFO = 'SET_PAY_PAGE_INFO'; // 设置支付页配置
export const UPDATE_IS_FINISH_INIT = 'UPDATE_IS_FINISH_INIT'; // 更新是否完成初始化
export const INIT_PAGE_LANG = 'INIT_PAGE_LANG'; // 初始化支付页语言
export const PRELOAD_IMAGE = 'PRELOAD_IMAGE'; // 预加载图片
export const UPDATE_IS_INSTALL = 'UPDATE_IS_INSTALL'; // 更新是否安装pwa
export const UPDATE_IS_LANDSCAPE = 'UPDATE_IS_LANDSCAPE'; // 更新是否横屏
export const UPDATE_IS_CLOSE_PWA_POPUP = 'UPDATE_IS_CLOSE_PWA_POPUP'; // 更新是否关闭pwa弹窗
export const UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP = 'UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP'; // 更新是否显示pwa跳转领奖弹窗
export const UPDATE_VISIBLE_GET_PWA_AWARD_SUCCESS_POPUP = 'UPDATE_VISIBLE_GET_PWA_AWARD_SUCCESS_POPUP'; // 更新是否显示pwa领奖成功弹窗

const getVisibleGotoAwardTipsPopup = () => {
  let _visibleGotoAwardTipsPopup = false;
  try {
    let _isInstallClick = sessionStorage?.getItem?.(`${gameId}_pwa_install_click`);
    _visibleGotoAwardTipsPopup = _isInstallClick == 1 || false;
    if (_isInstallClick) {
      sessionStorage?.removeItem?.(`${gameId}_pwa_install_click`);
    }
  } catch (error) {
    console.error(error)
  }
  return _visibleGotoAwardTipsPopup
}



export default {
  state: {
    isInstall: (() => {
      try {
        // 如果 window.isInstall 不存在，先创建它
        if (!window.isInstall) {
          window.isInstall = { value: true };
        }
        // 如果已经是响应式对象（通过 __ob__ 属性判断），直接返回
        if (window.isInstall.__ob__) {
          return window.isInstall;
        }
        // 创建响应式对象并同步到 window.isInstall
        const pwaState = Vue.observable(window.isInstall);
        window.isInstall = pwaState;
        // 由于本地开发的是否安装事件不会触发，所以模拟一下设置为false（未安装）
        if (process.env.NODE_ENV === 'development') {
          // pwaState.value = false;
        }
        return pwaState;
      } catch (e) {
        console.error(e);
        return { value: false };
      }
    })(), // 是否安装pwa
    openPwa: false, // 是否打开pwa
    pwaActivityName: '', // pwa领奖活动标识
    isClosePwaPopup: false, // 是否关闭pwa弹窗
    isLandscape: justifyLandscape(), // 是否横屏
    colorConfig: null, // 配色配置
    defaultLogin: 1, // 默认登录方式
    gearList: [], // 商品档位列表
    isFollowGameLang: 0, // 是否跟随游戏语言 0表示跟随
    isFollowGameLogin: 0, // 是否跟随游戏登录 0表示跟随
    // null：未从支付页 config 接口成功写入（含接口失败、未请求）；true/false：接口成功后的配置值
    matchCpProductid: null,
    openDoubleSend: false, // 是否开启双倍券
    faqLangJson: {}, // faq内容
    otpLangJson: {}, // otp语言配置
    otpPicList: {}, // otp图片列表
    couponPopupPicList: {}, // 优惠券弹窗素材图片列表
    languagesJson: {}, // 多语言
    languagesList: [], // 语言列表
    loginType: [], // 登录方式
    officialLink: '', // 官网链接
    socialLink: [], // 社群链接
    rightsLink: '', // 权益链接
    openGameAuth: 0, // 游戏授权登录【还没接入】
    openShoppingCart: 0, // 是否开启购物车
    picList: {}, // 图片资源列表
    isCustomProductType: false, // 是否自定义商品类型
    customProductType: {}, // 自定义商品类型列表
    customProductTypeLang: {}, // 自定义商品分类翻译
    isFinishInit: false, // 接口请求是否完成，用于判断一些dom是否可以显示
    visibleGotoAwardTipsPopup: getVisibleGotoAwardTipsPopup(), // 是否显示pwa跳转领奖弹窗
    visibleGetPwaAwardSuccessPopup: false // 是否显示pwa领奖成功弹窗
  },
  getters: {
    getCustomProductTypeDefaultKeys(state) {
      return Object.keys(state.customProductType).filter(item => state.customProductType[item]?.isDefault === 1) || [];
    }
  },
  mutations: {
    [UPDATE_IS_LANDSCAPE](state, isLandscape) {
      state.isLandscape = isLandscape;
    },
    [UPDATE_IS_INSTALL](state, isInstall) {
      // 修改响应式对象的 value 属性，而不是替换整个对象，保持响应式连接
      if (state.isInstall && typeof state.isInstall === 'object' && 'value' in state.isInstall) {
        state.isInstall.value = isInstall;
      } else {
        // 如果 state.isInstall 不是响应式对象，则创建新的响应式对象
        state.isInstall = Vue.observable({ value: isInstall });
        window.isInstall = state.isInstall;
      }
    },
    [UPDATE_IS_CLOSE_PWA_POPUP](state, isClosePwaPopup) {
      state.isClosePwaPopup = isClosePwaPopup;
    },
    [UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP](state, visibleGotoAwardTipsPopup) {
      state.visibleGotoAwardTipsPopup = visibleGotoAwardTipsPopup;
    },
    [UPDATE_VISIBLE_GET_PWA_AWARD_SUCCESS_POPUP](state, visibleGetPwaAwardSuccessPopup) {
      state.visibleGetPwaAwardSuccessPopup = visibleGetPwaAwardSuccessPopup;
    },
    [PRELOAD_IMAGE](state, info) {
      const configList = info.CONFIG_LIST || {};
      const picList = configList.pic_list
        ? JSON.parse(configList.pic_list)
        : {};
      const preloadImageList = [
        picList.fireTag1,
        picList.fireTag2,
        picList.fireTag3,
        picList.fireTag4
      ];
      preloadImageList.forEach(item => {
        if (item) {
          const img = new Image();
          img.src = item;
        }
      });
      const preloadImageContainer = document.createElement('div');
      preloadImageContainer.style.opacity = '0';
      preloadImageContainer.style.position = 'absolute';
      preloadImageContainer.style.top = '0';
      preloadImageContainer.style.left = '0';
      preloadImageContainer.style.width = '0';
      preloadImageContainer.style.height = '0';
      preloadImageContainer.style.overflow = 'hidden';
      document.body.appendChild(preloadImageContainer);
      preloadImageList.forEach(item => {
        const img = new Image();
        img.src = item;
        preloadImageContainer.appendChild(img);
      });
      document.body.removeChild(preloadImageContainer);
    },
    [SET_PAY_PAGE_INFO](state, info) {
      try {
        const configList = info.CONFIG_LIST || {};
        pushTrackEvent({
          eventName: 'set_page_info',
          eventType: 'page_info',
          eventValue: {
            matchCpProductid: configList.match_cp_productid
          }
        });
        state.colorConfig = configList.color_config || {};
        state.defaultLogin = +gameId === 2 ? 2 : +configList.default_login || '';
        state.gearList = configList.gear_list || [];
        state.isFollowGameLang = +configList.is_follow_game_lang || 0;
        state.isFollowGameLogin = +configList.is_follow_game_login || 0;
        if (configList?.match_cp_productid === '1') {
          state.matchCpProductid = true;
        } else if (configList?.match_cp_productid === '') {
          state.matchCpProductid = false;
        } else {
          state.matchCpProductid = null;
        }
        // if (FORCE_MATCH_CP_PRODUCTID_GAME_IDS.includes(+gameId)) {
        //   state.matchCpProductid = true;
        // }
        state.openDoubleSend = Number(configList?.open_double_send) === 1;
        try {
          if (configList.faq_lang_json) {
            state.faqLangJson = JSON.parse(configList.faq_lang_json) || {};
          }
        } catch (e) {
          console.log('faq_lang_json parse error', e);
          state.faqLangJson = {};
        }
        try {
          if (configList.otp_lang_json) {
            state.otpLangJson = JSON.parse(configList.otp_lang_json) || {};
          }
          if (configList.otp_pic_list) {
            state.otpPicList = JSON.parse(configList.otp_pic_list) || {};
          }
          if (configList.coupon_popup_pic_list) {
            state.couponPopupPicList =
              JSON.parse(configList.coupon_popup_pic_list) || {};
          }
        } catch (e) {
          console.log('otp_lang_json parse error', e);
          state.otpLangJson = {};
          state.otpPicList = {};
          state.couponPopupPicList = {};
        }
        state.languagesJson = configList.language_json
          ? JSON.parse(configList.language_json)
          : {};
        state.languagesList = configList.languages_list || '';
        state.loginType = configList.login_type || [];
        state.officialLink = configList.official_link || '';
        state.openGameAuth = +configList.open_game_auth || 0;
        state.openShoppingCart = +configList.open_shopping_cart || 0;
        state.picList = configList.pic_list
          ? JSON.parse(configList.pic_list)
          : {};
        state.socialLink = configList.social_link || [];
        state.rightsLink = configList.rights_link || '';
        const categoryListJson = configList.category_list_json;
        if (categoryListJson) {
          const categoryList = JSON.parse(categoryListJson);
          if (categoryList?.length > 0) {
            state.isCustomProductType = true;
            const customProductType = {
              [PRODUCT_TYPE_ALL]: {
                order: 0
              },
              [PRODUCT_TYPE_OTHER]: {
                order: 9999999
              }
            };
            categoryList?.forEach(item => {
              customProductType[`type${item.key}`] = {
                order: item.order,
                isDefault: item.is_default || 0
              };
            });
            const _customProductTypeLang = categoryList.reduce((acc, item) => {
              const langCodes = Object.keys(item).filter(key =>
                key.includes('-')
              );
              langCodes.forEach(langCode => {
                if (!acc[langCode]) {
                  acc[langCode] = {};
                }
                if (item[langCode]) {
                  acc[langCode][`type${item.key}`] = item[langCode];
                }
              });
              return acc;
            }, {});
            state.customProductType = customProductType;
            state.customProductTypeLang = _customProductTypeLang;
          }
        }

        state.openPwa = Number(configList?.open_pwa) === 1;
        state.pwaActivityName = configList?.pwa_activity_name || '';

        try {
          if (state.openPwa) {
            window.pwaName[gameId] = window.btoa(
              encodeURIComponent(configList?.pwa_name || 'officialTopupNew')
            );
            window.pwaIcon[gameId] = state.picList?.iconpwa || state.picList?.icon || '';
            window.initPwaHandler();
          } else {
            state.isInstall.value = false;
          }
        } catch (e) {
          console.error(e);
        }
      } catch (e) {
        errorReport(ERROR_TYPE.SET_PAGE_INFO_FAIL, {
          error: e?.message || 'unknown error'
        });
      }
      this.dispatch(INIT_PAGE_LANG);
    },
    [UPDATE_IS_FINISH_INIT](state, isFinishInit) {
      // trackStagePoint('page_update_is_finish_init', { isFinishInit });
      state.isFinishInit = isFinishInit;
    }
  },
  actions: {
    // 获取活动列表信息
    [GET_PAY_PAGE_INFO]({ rootState }) {
      const url = +gameId === 2 ? JP_GET_PAGE_URL : GET_PAGE_URL;
      return getJSON(url, gameIdTransform({
        game_id: rootState.gameId
      }))
        .then(({ res, errmsg }) => {
          if (errmsg) {
            errorReport(ERROR_TYPE.GET_PAY_PAGE_INFO_FAIL, {
              result: res?.result,
              errmsg: errmsg || res?.msg,
            });
            this.commit(UPDATE_IS_FINISH_INIT, true);
            return false;
          }
          if (+res?.result === 1) {
            this.commit(SET_PAY_PAGE_INFO, res.data);
            this.commit(PRELOAD_IMAGE, res.data);
            this.commit(UPDATE_IS_FINISH_INIT, true);
            if (res?.data?.DOMAIN_LIST) {
              res.data.DOMAIN_LIST = mergeGameDomainList(res?.data?.DOMAIN_LIST);
            }
            return res.data;
          } else {
            this.commit(UPDATE_IS_FINISH_INIT, true);
            return false;
          }
        })
        .catch(err => {
          errorReport(ERROR_TYPE.GET_PAY_PAGE_INFO_FAIL, {
            error: err?.message || String(err)
          });
          this.commit(UPDATE_IS_FINISH_INIT, true);
          return false;
        });
    },
    // 初始化支付页语言
    [INIT_PAGE_LANG]({ rootState, state }) {
      // 设置初始语言
      let curPageLang = globalConfig.getLclStorageItem(
        LANGUAGE_LOCALSTORGE_NAME
      );
      if (curPageLang?.includes('pt')) {
        curPageLang = 'pt-PT';
      }
      if (!state.languagesList.includes(curPageLang)) {
        const defaultLang = state.languagesList[0];
        if (defaultLang) {
          globalConfig.setLclStorageItem(
            LANGUAGE_LOCALSTORGE_NAME,
            defaultLang
          );
          this.dispatch(SWITCH_LANGUAGE, defaultLang, { root: true });
        }
      }

      // 设置语言列表
      const langMap = {};
      state.languagesList.forEach(lang => {
        langMap[lang] = rootState.langList[lang];
      });
      this.commit(INIT_LANG_LIST, langMap, { root: true });
      // 设置多语言对象
      const newLangMap = languages.getLangMap();
      for (let key in state.languagesJson) {
        Object.assign(newLangMap[key], state.languagesJson[key]);
      }
      languages.setLangMap(newLangMap);
    }
  }
};
